export const NOTE_MAX_LENGTH = 10000;

export const blankFollowUpForm = {
  assigneeId: null,
  dueDate: null,
  callDispositionId: null,
  statusId: null,
  note: '',
};

export const blankEntryForm = {
  statusId: null,
  note: '',
};

export const selectOptions = (items, labelBuilder = (item) => item.name) => (
  (items || []).map((item) => ({
    value: item.id,
    label: labelBuilder(item),
  }))
);

export const assigneeOptionLabel = (assignee) => (
  assignee.email ? `${assignee.name} (${assignee.email})` : assignee.name
);

export const normalizeId = (value) => (
  value === undefined || value === null || value === '' ? null : Number(value)
);

export const createDefaultsFromOptions = (options) => ({
  ...blankFollowUpForm,
  statusId: options?.call_followup_statuses?.[0]?.id || null,
});

export const formFromFollowup = (followup = {}) => ({
  assigneeId: followup.assignee_id || null,
  dueDate: followup.due_date || null,
  callDispositionId: followup.call_disposition_id || null,
});

export const changedFollowUpFields = (form, followup = {}) => {
  const changes = {};
  if (normalizeId(form.assigneeId) !== normalizeId(followup.assignee_id)) changes.assignee_id = form.assigneeId || null;
  if ((form.dueDate || null) !== (followup.due_date || null)) changes.due_date = form.dueDate;
  if (normalizeId(form.callDispositionId) !== normalizeId(followup.call_disposition_id)) {
    changes.call_disposition_id = form.callDispositionId || null;
  }
  return changes;
};

export const safeFollowUpErrorMessage = (
  error,
  fallback = 'Unable to update follow-up. Please try again.',
  options = {},
) => {
  const status = error?.response?.status;
  const rawError = error?.response?.data?.error || '';
  if (status === 400 && /already|taken|conflict/i.test(rawError)) {
    return 'A follow-up already exists for this call. Close and reopen the call to refresh.';
  }
  if (status === 403) {
    return 'You do not have access to call follow-ups.';
  }
  if (status === 404) {
    return options.notFoundMessage || 'Follow-up was not found. Close and reopen the call to refresh.';
  }
  return fallback;
};
